import script from "./ClaimableAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimableAmount.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__